<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div class="col-2 d-flex">
          <div
            class="type-header d-flex flex-column"
            [ngClass]="beamlineShutterRelation?.statusClass"
          >
            <h1>{{ beamlineShutterRelation?.beamlineName }}</h1>
            <span>{{ beamlineShutterRelation?.beamlineStatus }}</span>
          </div>
        </div>
        <div class="col-5 d-flex align-items-center">
          <nav mat-tab-nav-bar #tabs class="full-width" [tabPanel]="tabPanel">
            <a
              mat-tab-link
              *ngFor="let link of links"
              (click)="onTabChanged(link)"
              [routerLink]="['/resources-new']"
              [queryParams]="{ tab: links.indexOf(link) }"
              [active]="selectedTab == link.id"
              [ngClass]="{ hidden: links.indexOf(link) > 0 && showHistory }"
            >
              {{ link.name }}
            </a>
          </nav>
          <mat-tab-nav-panel #tabPanel class="flex flex-col flex-auto h-full">
            <div>
              <router-outlet></router-outlet>
            </div>
          </mat-tab-nav-panel>
        </div>

        <div
          class="col-3 small d-flex flex-column align-items-end justify-content-center"
          *ngIf="pendingResource && toggleVisible; else lastUpdate"
        >
          <div class="d-flex justify-content-end">
            <span> Modified by:&nbsp;</span>
            <span class="bold yellow">{{
              pendingResource.userCreatedBy?.name
            }}</span>
            &nbsp;on:&nbsp;
            <span class="date">{{ pendingResource.createdOn | date }}</span>
          </div>

          <mat-slide-toggle
            [(ngModel)]="showChanges"
            (change)="changeShow($event)"
          >
            Show Modification
          </mat-slide-toggle>
        </div>
        <ng-template #lastUpdate>
          <div class="col-3 pr-0 d-flex justify-content-end">
            <last-update [detailUsers]="detailUsers"></last-update>
          </div>
        </ng-template>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <!-- //#region List -->
            <resources-list-new
              [selectedTab]="selectedTab"
              [beamlineShutter]="beamlineShutterRelation"
              [beamlineShutterRelations]="beamlineShutterRelations"
              (rowSelectionStarted)="startRowSelectionLoading()"
              (selectedRow)="selectedRow($event)"
            ></resources-list-new>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          class="parent"
          *ngIf="
            beamlineShutterRelation &&
            !toggleVisible &&
            selectedTab == 0 &&
            !showHistory
          "
          (click)="history(true)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Show History</span
          >
          <mat-icon matListItemIcon class="blue">history</mat-icon>
        </mat-list-item>

        <mat-list-item
          class="parent"
          *ngIf="beamlineShutterRelation && selectedTab == 0 && showHistory"
          (click)="history(false)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Hide History</span
          >
          <span matListItemIcon class="orange material-symbols-outlined">
            history_off
          </span>
        </mat-list-item>

        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="privileges.canCreate && selectedTab == 0"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="keBuilder.create()"
          class="parent"
          *ngIf="selectedTab == 1 && keBuilder?.canCreateDraftVersion()"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create Template</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="keBuilder.duplicate()"
          class="parent"
          *ngIf="selectedTab == 1 && keBuilder?.canCreateDraftVersion()"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Duplicate</span
          >
          <mat-icon matListItemIcon class="blue">content_copy</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="keBuilder.recreate()"
          class="parent"
          *ngIf="!!keBuilder && selectedTab == 1 && keBuilder?.createAllowed"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Update values</span
          >
          <mat-icon matListItemIcon class="pink">update</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="keBuilder.delete()"
          class="parent"
          *ngIf="
            selectedTab == 1 &&
            keBuilder?.createAllowed &&
            keBuilder.status != 1
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Delete</span>
          <mat-icon matListItemIcon class="red">delete</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="keBuilder.approveVersion()"
          class="parent"
          *ngIf="!!keBuilder && selectedTab == 1 && keBuilder?.approveAllowed"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Approve Template</span
          >
          <mat-icon matListItemIcon class="green">done</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div
        class="sidenav-content"
        [ngClass]="{
          amendment: false,
        }"
      >
        <app-resource-details-new
          [showChanges]="showChanges"
          [showHistory]="showHistory"
          [beamlineShutterRelations]="beamlineShutterRelations"
          [beamlineShutter]="beamlineShutterRelation"
          (cancelAdd)="beamlineShutterRelation = undefined"
          (showChangesChange)="showChanges = $event"
          (createdPendingID)="selectNewPending($event)"
          (selectionLoadFinished)="finishRowSelectionLoading()"
          *ngIf="selectedTab == 0"
        ></app-resource-details-new>
        <rss-test-database
          #rssTest
          [beamlineShutter]="beamlineShutterRelation"
          [showChanges]="showChanges"
          (selectionLoadFinished)="finishRowSelectionLoading()"
          *ngIf="selectedTab == 2"
        ></rss-test-database>
        <ke-checklist-builder
          #keBuilder
          [ngClass]="{ hidden: selectedTab != 1 }"
          [beamlineShutter]="beamlineShutterRelation"
          [active]="selectedTab == 1"
          (selectionLoadFinished)="finishRowSelectionLoading()"
        ></ke-checklist-builder>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
